export default __webpack_public_path__ + "assets/svg/advagym_a_white.2df2ec7b074b4f52f21978988c80a7d1.svg";